
export const pausedColor = "#ff0000";
export const stateColor = "#00FF7F";
export const unusedColor = "#808080";



// WEBPACK FOOTER //
// ./src/views/pages/chargers/stations/map/map-filter-items.js